import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Environment: React.FC = () => (
  <div className="sf-future-vision">
    <section className="sf-future-vision-intro tw-py-[clamp(3rem,6vw,5rem)]">
      <Container className="sf-future-vision-container">
        <p className="sf-future-vision-eyebrow">FUTURE VISION</p>
        <h1>Environment</h1>
        <p className="sf-future-vision-lead tw-max-w-[56rem]">Environmental awareness and sustainable community practices are part of Srisailam Foundation's long-term vision, not a currently active programme.</p>
      </Container>
    </section>

    <section className="tw-py-[clamp(2.8rem,5vw,4.4rem)]">
      <Container className="sf-future-vision-container">
        <div className="tw-grid tw-gap-6 md:tw-grid-cols-2 md:tw-gap-8">
          <article className="sf-future-vision-card">
            <h2>Our Vision</h2>
            <div className="tw-mb-4 tw-h-1 tw-w-12 tw-rounded-full tw-bg-sf-teal" aria-hidden="true" />
            <p>As the Foundation grows, we aspire to explore ways to support environmental awareness, depending on community needs, available resources and organisational capacity.</p>
          </article>
          <article className="sf-future-vision-card">
            <h2>Our Current Focus</h2>
            <div className="tw-mb-4 tw-h-1 tw-w-12 tw-rounded-full tw-bg-sf-gold" aria-hidden="true" />
            <p>Srisailam Foundation currently provides free education and learning support for children studying up to Class 8.</p>
          </article>
        </div>
      </Container>
    </section>

    <section className="sf-future-vision-support tw-py-[clamp(2.8rem,5vw,4.4rem)]">
      <Container className="sf-future-vision-container">
        <div className="sf-future-vision-card">
          <h2>Support Our Current Work</h2>
          <p>Support our ongoing efforts to make education and learning opportunities more accessible to children.</p>
          <Link className="sf-future-vision-cta tw-inline-block" to="/donate">Support Our Current Work</Link>
        </div>
      </Container>
    </section>
  </div>
);

export default Environment;
